// eslint-disable-next-line import/no-cycle
import userService from '@client/services/user';
// eslint-disable-next-line import/no-cycle
import accountRequestService from '@client/services/accountRequest';
// eslint-disable-next-line import/no-cycle
import publiclyTradedCompany from '@client/store/modules/user/employment/publiclyTradedCompany';
// eslint-disable-next-line import/no-cycle
import publicOfficialInformation from '@client/store/modules/user/employment/publicOfficialInformation';
import {EMPLOYMENT_STATUS_LIST} from '@client/constants/employmentStatusList';
import {US_STATES} from '@client/constants/usStates';

const stateObj = {
  current: {
    sourceOfIncome: '',
    clientisId: '',
    occupation: '',
    businessName: '',
  },
  employmentList: EMPLOYMENT_STATUS_LIST,
  states: US_STATES,
  entityExchange: {
    authorizationFileName: null,
    authorizationFileBase64: null,
    authorizationFileFormat: null,
    disable: null,
    exchangeEntityName: null,
  },
};

const getters = {
  isValid: (state) => {
    if (state.current) {
      return state.current.clientisId !== '' &&
        state.current.sourceOfIncome !== '' &&
        state.current.clientisId !== 1 &&
        state.current.clientisId !== 2 &&
        state.current.sourceOfIncome !== null
        ? true
        : !!(
            (state.current.clientisId === 1 || state.current.clientisId === 2) &&
            state.current.businessName !== '' &&
            state.current.occupation !== ''
          );
    }

    return false;
  },
  usStates: (state) => state.states,
};

const actions = {
  async get({commit, dispatch, state, rootGetters}) {
    const userId = rootGetters['cognitoUser/userId'];

    try {
      const disclosures = await userService.getDisclosures(userId);
      const {publicCompanyHolder, politicalExposureDetail} = disclosures;
      const toRoot = {root: true};

      dispatch('user/employment/publiclyTradedCompany/set', publicCompanyHolder, toRoot);
      dispatch('user/employment/publicOfficialInformation/set', politicalExposureDetail, toRoot);

      const empDetails = await accountRequestService.getEmploymentData({userId});

      if (!empDetails) {
        return {
          employmentDetails: null,
        };
      }

      const empStatusInfo = state.employmentList.find((emp) => emp.code === empDetails.employmentStatus);

      delete empDetails.address;
      const result = {
        clientisId: empStatusInfo?.id,
        // eslint-disable-next-line unicorn/consistent-destructuring
        businessName: empDetails?.employerName,
        // eslint-disable-next-line unicorn/consistent-destructuring
        sourceOfIncome: empDetails?.sourceOfIncome,
        clProfessionDesc: empStatusInfo?.description,
        // eslint-disable-next-line unicorn/consistent-destructuring
        occupation: empDetails?.occupation,
        code: empStatusInfo?.code,
      };

      commit('SET', result);

      return {
        employmentDetails: result,
      };
    } catch (error) {
      throw new Error(error);
    }
  },
  async save({rootState, state}) {
    const account = rootState.account.toAdd;
    const payload = {
      accountType: account ? account.account_name.toUpperCase().replace(' ', '_') : null,
      clUserId: rootState.user.id,
      custodian: 'APEX',
      requestInitiator: rootState.account.requests.current[0].request_initiated_from,
      employment: {
        employerName: state.current.businessName,
        employmentStatus: state.current.code,
        occupation: state.current.occupation,
        sourceOfIncome: state.current.sourceOfIncome,
      },
      id: rootState.account.requests.current[0].request_id,
    };

    try {
      const response = await accountRequestService.updateAccountRequest(payload);

      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  // eslint-disable-next-line require-await
  async setEmploymentStatus({commit}, payload) {
    commit('SET_EMPLOYMENT_STATUS', payload);
  },
  // eslint-disable-next-line require-await
  async setIncomeSource({commit}, payload) {
    commit('SET_INCOME_SOURCE', payload);
  },
  // eslint-disable-next-line require-await
  async setOccupation({commit}, payload) {
    commit('SET_OCCUPATION', payload);
  },
  // eslint-disable-next-line require-await
  async setEmployer({commit}, payload) {
    commit('SET_EMPLOYER', payload);
  },
  // eslint-disable-next-line require-await
  async setPtcSelected({commit}, payload) {
    commit('SET_PTC_SELECTED', payload);
  },
  // eslint-disable-next-line require-await
  async setSpfSelected({commit}, payload) {
    commit('SET_SPF_SELECTED', payload);
  },
  // eslint-disable-next-line require-await
  async setFaiSelected({commit}, payload) {
    commit('SET_FAI_SELECTED', payload);
  },
  setFaiDetails({commit}, payload) {
    commit('SET_ENTITY_EXCHANGE', payload);
  },
};

const mutations = {
  SET(state, payload) {
    state.current = payload;
  },
  SET_EMPLOYMENT_STATUS(state, payload) {
    state.current.clientisId = payload.id;
    state.current.clProfessionDesc = payload.description;
    state.current.code = payload.code;
  },
  SET_INCOME_SOURCE(state, payload) {
    state.current.sourceOfIncome = payload;
  },
  SET_OCCUPATION(state, payload) {
    state.current.occupation = payload;
  },
  SET_EMPLOYER(state, payload) {
    state.current.businessName = payload;
  },
  SET_ENTITY_EXCHANGE(state, payload) {
    if (payload) {
      state.entityExchange = payload;
    }
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
  modules: {
    publiclyTradedCompany,
    publicOfficialInformation,
  },
};
